import { ELocaleCode } from '@core/modules/intl/domain/enums';

export const venueViewI18n = {
	[ELocaleCode.RU_RU]: {
		archive: 'Архивировать',
		unarchive: 'Разархивировать',
		notFoundError: 'Место не найдено',
		name: 'Название',
		categories: 'Категории',
	},
	[ELocaleCode.EN_US]: {
		archive: 'Archive',
		unarchive: 'Unarchive',
		notFoundError: 'Venue not found',
		name: 'Name',
		categories: 'Categories',
	},
};
